var cilBrowser = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M472,40H40A24.028,24.028,0,0,0,16,64V448a24.028,24.028,0,0,0,24,24H472a24.028,24.028,0,0,0,24-24V64A24.028,24.028,0,0,0,472,40ZM48,72h96v72H48ZM464,440H48V176H464Zm0-296H176V72H464Z' class='ci-primary'/>"];

export { cilBrowser };

